import { FsListConfig, PaginationStrategy } from '@firestitch/list';

export const ListDefaultConfig: FsListConfig = {
  queryParam: true,
  chips: true,
  persist: false,
  reload: true,
  paging: {
    strategy: PaginationStrategy.Offset,
    limit: 25,
  },
};
